import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = 'Search';
  @Input() checkIfFromArtis: any = false;
  @Input() mainSearch: any = false;
  @Input() songsTemp: any = new Array<any>();
  tempsongs: any = [];
  tempsongs2: any = [];
  @Input() initVal: string = '';
  @Output() onSearched: EventEmitter<any> = new EventEmitter<any>();
  private inputSubscriber: any = null;
  private DEBOUNCE_VALUE: number = 500;

  constructor() {

  }

  ngOnInit() {
    this.inputSubscriber = this.inputChanges(this.DEBOUNCE_VALUE)
      .subscribe((input) => {
        this.onSearched.emit({ searchTerm: input });
      });
  }

  emitInput: (event: KeyboardEvent) => void;

  //sets up emitInput to start sending values
  inputChanges(debounce: number): Observable<string> {
    return Observable.create(observer => {
      this.emitInput = (event: KeyboardEvent) => {
        observer.next((<HTMLInputElement>event.target).value);
      };
    }).distinctUntilChanged().debounceTime(debounce);
  }

  ngOnDestroy() {
    if (this.inputSubscriber != null) {
      this.inputSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/searchbar/searchbar.component.ts